<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Object,
    default: () => {},
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});

function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }
  const chartInstance = echarts.init(myEcharts.value);

  let list = [{
    name: '项目完成进度',
    value: 100
  }];
  let yName = list.map((item) => item.name);
  let xData = list.map((item) => item.value);
  let barWidth = 16;
  let totaldata=[100]
  const option= {

    xAxis: {
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      }
    },
    grid: {
      containLabel: true,
      left: 6,
      top: 0,
      right: 100,
      bottom: 0
    },
    yAxis: [{
      inverse: true,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        margin: 10,
        textStyle: {
          fontSize: 14,
          color: '#fff'
        }
      },
      data: yName,
    }],
    series: [{ //内
      type: 'bar',
      barWidth,
      legendHoverLink: false,
      symbolRepeat: true,
      silent: true,
      itemStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: 'rgba(58,253,185,0)' // 0% 处的颜色
          }, {
            offset: 1,
            color: '#3AFDB9' // 100% 处的颜色
          }]
        }
      },
      data: list,
      z: 1,
      animationEasing: 'elasticOut'
    },
      { // 背景
        type: 'pictorialBar',
        animationDuration: 0,
        symbolRepeat: 'fixed',
        symbolMargin: '20%',
        symbol: 'roundRect',
        symbolSize: [6, barWidth],
        itemStyle: {
          normal: {
            color: 'transparent',
          }
        },
        label: {
          normal: {
            show: true,
            position: 'right',
            offset: [0, 2],
            distance: 20,
            textStyle: {
              color: '#3AFDB9',
              fontSize: 14,
            },
            formatter: function (a, b) {
              console.log(a);
              console.log(b);
              return `${a.value}%`
            }
          },

        },
        data: xData,
        z: 0,
        animationEasing: 'elasticOut'
      },
      { //分隔
        type: 'pictorialBar',
        itemStyle: {
          color: '#000'
        },
        symbolRepeat: 'fixed',
        symbolMargin: 2,
        symbol: 'roundRect',
        symbolClip: true,
        symbolSize: [2, barWidth],
        symbolPosition: 'start',
        symbolOffset: [0, 0],
        data: list,
        z: 2,
        animationEasing: 'elasticOut'
      },
    ]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option, true);
}
window.addEventListener("resize", () => {
  chartInstance.resize();
});

</script>
<style lang="less"></style>
